<template>
  <div class="login">
    <div class="title">{{this.$store.state.currentTitle.homeTitle}}</div>
    <div class="en">
      <em>welcome</em>
    </div>
    <div class="loginContent flex-box flex-d-c flex-b flex-h-v">
      <label for="mobileNum" class="mb5 bb mobileNum cell flex-box flex-v-c">
        <input
          id="mobileNum"
          class
          type="tel"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="mobileNum"
        >
      </label>
      <div class="flex-box mb5 bb cell">
        <label for="verifyCode" class="mr10 flex2 flex-box">
          <input
            id="verifyCode"
            class="flex1"
            type="number"
            @blur="onblur"
            placeholder="请输入验证码"
            v-model="verifyCode"
          >
        </label>
        <div
          class="flex1 flex-box flex-hv-c getCode"
          :class="{hasmob:this.$common.common.isValidMobileNum(this.mobileNum)}"
          @click.stop="getCode"
          v-show="isShow"
        >获取验证码</div>
        <div class="flex1 flex-box flex-hv-c getCode" v-show="!isShow">重新获取({{count}})</div>
      </div>
      <div
        @click.stop="login"
        class="loginBtn flex-box flex-hv-c"
        :class="{canClick:mobileNum&&verifyCode.toString().length==6}"
      >登录</div>
    </div>
  </div>
</template>
<!--javascript-->
<script>
//  import {Toast} from 'mint-ui';
export default {
  data() {
    return {
      getCodeUrl: "",
      mobileNum: "",
      verifyCode: "",
      verifyType: 2,
      count: "",//倒计时显示
      isShow: true,
      timer: null
    }
  },
  methods: {
    /**********
     * 获取验证码
     * *******/
    getCode() {
      let that = this
      if (!that.mobileNum) {
        that.$toast("请先输入手机号")
        return
      }
      if (!that.$common.common.isValidMobileNum(that.mobileNum)) {
        that.$toast("请先输入正确的手机号")
        return
      }
      that.isShow = false
      const TIME_COUNT = 60;
      that.count = TIME_COUNT

      let set = setInterval(function () {
        that.count--
        if (that.count == 0) {
          that.isShow = true
          clearInterval(set)
        }
      }, 1000)

      this.$http.get('/common/verifyCode/get', {
        params: {//get写法
          mobileNum: this.mobileNum,
          verifyType: this.verifyType
        }
      }).then(function (res) {
        console.log(res);
        if (res.code == 0) {
          that.$toast(res.message)
        } else {
          that.$toast(res.message)
          if (res.message == '手机号无效' || res.message == '该手机号未注册') {
            that.isShow = true
            clearInterval(set)
          }
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    /**********
     * 登录
     * *******/
    login() {
      let that = this;
      that.onblur()
      if (!this.mobileNum) {
        that.$toast("请输入手机号")
        return
      }
      if (!this.verifyCode) {
        that.$toast("请输入验证码")
        return
      }
      this.$http.post('/user/login', {
        mobileNum: this.mobileNum,
        verifyCode: this.verifyCode
      })
        .then(function (res) {
          console.log(res);
          localStorage.setItem("code", res.code)
          if (res.code == 0) {
            //              Toast("登录成功")
            console.log(res)
            localStorage.setItem("token", res.data.token)
            localStorage.setItem("env", res.env.replace('-test', ''))
            localStorage.setItem("managerId", res.data.managerId)
            localStorage.setItem("startTime", res.data.startTime)
            localStorage.setItem("endTime", res.data.endTime)
            that.$store.dispatch('getUserMsg')//初始请求用户信息 得到数据 存放store中
            that.$router.push('/home');
          } else if (res.code == 9999) {
            //              this.$router.push('/login');
          } else {
            that.$toast(res.message)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onblur() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  },
  watch: {
    mobileNum() {
      if (this.mobileNum.length > 11) {
        this.mobileNum = this.mobileNum.slice(0, 11)
      }
    },
    verifyCode() {
      if (this.verifyCode.length > 6) {
        this.verifyCode = this.verifyCode.slice(0, 6)
      }
    }
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.login {
  background: #3d435f;
  background-attachment: fixed;
  background: linear-gradient(
    150deg,
    #fff 0%,
    #fff 29.9%,
    #3d435f 30%,
    #3d435f 100%
  );
  width: 100vw;
  height: 100vh;
  // position: fixed;
  // left: 0;
  .loginContent {
    // position: fixed;
    // top: 60%;
    // left: 50%;
    margin: 4.5rem auto 0 auto;
    width: 75vw;
    height: 3rem;
    // -webkit-transform: translate3d(-50%, -50%, 0);
    // transform: translate3d(-50%, -50%, 0);
  }
  .title {
    font-size: 16px;
    color: #3d435f;
    font-weight: bold;
    letter-spacing: 1px;
    margin: 0.2rem;
  }
  .en {
    color: #3d435f;
    text-decoration: underline;
    margin: 0 0.2rem;
  }
  .getCode {
    color: #898c9a;
  }
  .hasmob {
    color: #fff;
  }
  .cell {
    height: 0.6rem;
  }
  input {
    background: transparent;
    color: #fff;
  }

  .loginBtn {
    color: #898c9a;
    min-height: 35px;
    margin-top: 10px;
    border: 1px solid #898c9a;
    transition: all 0.5s;
  }
  .canClick {
    background: #fff;
    color: #3d435f;
    border: none;
    border-radius: 25px;
    box-shadow: 0 0 2px #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue